import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { messages } from '../../../../helpers/messages';
import { transactionsService } from '../../../../services/transactions-service';
import { userService } from '../../../../services/user-service';
import { TransactionsProducer } from './transactionHelper';
import LoaderDetailed from './Loader/LoaderDetailed';
import { methods } from '../helper';
import { cashBoxService } from '../../../../services/cashbox-service';
import { ConfirmModal } from '../../../common';
import {CANCEL_TRANSACTION, EDIT_TRANSACTION, listRoles} from '../../../../helpers/data-constants';
import {cashValue, getUserFromLocalStorage, permissionsAccess, returnAnnuityDealType} from '../../../../helpers/common';
import { useRecalculation } from '../../../utilites';
import { ModalInboxOperationEdit } from "../../modals";
import { getLastTransaction } from '../../../../redux/actions/transactionsAction';

import '../../reports.scss';
import { transactionDate } from '../../../../helpers/common';

let SIZE = 20;

let transactionsProducer = TransactionsProducer(transactionsService, userService, SIZE);


const TransactionsDetailed = ({ cashBoxIds, startDate, endDate, rerender, onRevert, cash, cashBox, successRolesAllCash, isFilterSelected, onFilterSelected }) => {
  const [state, setState] = useState({
    transactions: [],
    reasons: {},
    page: 1,
    totalElements: 0,
    loading: false,
  });
  const [revertTransaction, setRevertTransaction] = useState(undefined);
  const { accessRoles, accessFeatures } = useSelector(({ user }) => user);
  const userRoles = getUserFromLocalStorage().roles;
  const isGoodsSpecialist = userRoles.includes(listRoles.GOODS_SPECIALIST);
  const [modalEditTransaction, setModalEditTransaction] = useState(false);
  const [transactionToEdit, setTransactionToEdit] = useState({})
  const { editTransaction: successfulEditTransaction } = useSelector(({ transactions }) => transactions)
  const dispatch = useDispatch();
  const { isRecalculationTransaction } = useRecalculation({calc: {}});
  const isNonCashOperationCrediton = accessFeatures['non_cash.operations.type']

  const currentPage = useMemo(() => (isFilterSelected ? 1 : state.page), [isFilterSelected, state.page]);

  useEffect(() => {
    setState({...state, page: 1});
  }, [startDate, endDate]);

  useEffect(() => {
    getTransactions(currentPage);
  }, [startDate, endDate, cashBoxIds, state.page, rerender, cash, successfulEditTransaction, currentPage]);

  const error = (err) => {
    if (err.response) {
      let errorData = err.response.data;
      let commonError = messages['0'];
      if (errorData.errorCode) {
        commonError = messages[errorData.errorCode];
      }
      setState((prev) => ({
        ...prev,
        loading: false,
        error: commonError,
      }));
    }
  };

  const getTransactions = (page) => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));

    const args = [startDate, endDate, cashBoxIds, page, undefined, cash]

    if (successRolesAllCash && cashBox.length === 0) {
      args.splice(2, 1, null);
    }
    let promises = [
      transactionsProducer.getTransactions(...args),
    ];
    if (page === 1) {
      promises.push(cashBoxService.getReasons(''));
    }
    Promise.all(promises)
        .then(([{transactions, totalElements}, reasonsResponse]) => {
          let reasons = state.reasons;
          if (page > 1) {
            transactions = [...state.transactions, ...transactions];
          } else {
            let reasonsArray = reasonsResponse.data.reasons;
            reasons = {};
            reasonsArray.forEach((value) => {
              reasons[value.code + ''] = value;
            });
          }
          setState((prev) => ({
            ...prev,
            reasons: reasons,
            transactions: transactions,
            totalElements: totalElements,
            loading: false,
          }));
        })
        .catch(error);
  };

  const handleRevert = (transaction) => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    transactionsService
      .revertTransaction(transaction.id)
      .then(() => {
        state.transactions.forEach((tr) => {
          if (tr.id === transaction.id) {
            tr.reverted = true;
          }
        });
        if (onRevert) {
          onRevert();
        }
        setState((prev) => ({
          ...prev,
          transactions: state.transactions,
          loading: false,
        }));
      })
      .catch(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      });
  };

  const handleShowMore = () => {
    setState((prev) => ({
      ...prev,
      page: currentPage + 1,
    }));
    onFilterSelected(false)
  };

  const returnButton = (transaction) => {
    if (userRoles.length) {
      const accessRoles = userRoles.filter(
        (i) => i === listRoles.ADMIN || i === listRoles.DIRECTOR || listRoles.BRANCH_DIRECTOR
      ).length;

      if (!isGoodsSpecialist && userRoles.length === 1) {
        return (
          <button
            className="button-tab transaction-button"
            onClick={() => {
              setRevertTransaction(transaction);
            }}>
            Отменить
          </button>
        );
      }
      else {
        if (accessRoles) {
          return (
            <button
              className="button-tab transaction-button"
              onClick={() => {
                setRevertTransaction(transaction);
              }}>
              Отменить
            </button>
          );
        }
        else {
          if (
            moment(moment(transaction.createDate).utc().format('YYYY-MM-DD'))
              .isSame( moment().utc().format('YYYY-MM-DD'))
            ||
            moment(moment(transaction.createDate).utc().format('YYYY-MM-DD'))
              .isSame(moment().utc().add(-1, 'days').format('YYYY-MM-DD'))
          ) {
            return (
              <button
                className="button-tab transaction-button"
                onClick={() => {
                  setRevertTransaction(transaction);
                }}>
                Отменить
              </button>
            );
          }
          else {
            return null;
          }
        }
      }
    }
  };

  const openModalForTransactionEdit = (transaction) => {
    dispatch(getLastTransaction(transaction.type));
    setTransactionToEdit(transaction)
    setModalEditTransaction(true)
  }

  const closeModalEditTransaction = () => {
    setModalEditTransaction(false)
  }

  const transactionUpdate = (transaction) => {
    return (permissionsAccess("action.transaction.update")
        && !transaction.reverted
        && methods.isRevertable(transaction.section)
        && accessFeatures['cash.operations.edit'])
        || (accessFeatures['deals.refund_things']
        && permissionsAccess("action.refund.transaction.update")
        && transaction.section === 'REFUND_REALISED_THING'
        || isRecalculationTransaction(transaction))
  }

  const transactionReverted = (transaction) => `${transaction.reverted ? 'reverted' : ''}`

  return state.loading ? (
    <LoaderDetailed pageRange={10} />
  ) : (
    <>
      <table className="table fullwidth">
        <thead>
          <tr>
            <th scope="col">Тип транзакции</th>
            <th scope="col">Описание</th>
            <th scope="col">Номер договора</th>
            <th scope="col">Тип договора</th>
            <th scope="col">Товаровед</th>
            <th scope="col">Дата</th>
            <th scope="col">Приход, BYN</th>
            <th scope="col">Расход, BYN</th>
            <th scope="col">Форма оплаты</th>
            { (accessRoles[EDIT_TRANSACTION] || accessRoles[CANCEL_TRANSACTION]) && <th scope="col"/>}
          </tr>
        </thead>
        <tbody>
        {state.transactions &&
            state.transactions.map((transaction) => {
              return (
                  <tr key={transaction.id}
                      className={
                        `${transaction.section.startsWith('REPAYMENT_')
                            ? transaction.section.startsWith('REPAYMENT_CREDIT')
                                ? 'row-color_second color-accept'
                                : 'row-color color-issue'
                            : ''}`
                      }>
                    <th scope="row" className={transactionReverted(transaction)}>
                      <span className="caption">Тип транзакции</span>
                      <p>{methods.convertGroupType(transaction.section, state.reasons)}</p>
                    </th>
                    <td className={transactionReverted(transaction)}>
                      <span className="caption">Описание</span>
                      <p dangerouslySetInnerHTML={{__html: transaction.description.replace(/(Простить проценты = |Простить пени = |Простить неустойку = )(\d+\.\d+)/g, '$1<del>$2</del>')}}></p>
                    </td>
                    <td className={transactionReverted(transaction)}>
                      <span className="caption">Номер договора</span>
                      <Link
                          className="table-link"
                          to={`/client/${transaction.clientId}/contracts/${transaction.dealId}`}>
                        <span>{transaction.dealNumber}</span>
                      </Link>
                    </td>
                    <td className={transactionReverted(transaction)}>
                      <span className="caption">Тип договора</span>
                      <p>{returnAnnuityDealType(transaction.dealDuration)}</p>
                    </td>
                    <td className={transactionReverted(transaction)}>
                      <span className="caption">Товаровед</span>
                      <p>{transaction.user && transaction.user.fullName}</p>
                    </td>
                    <td className={transactionReverted(transaction)}>
                      <span className="caption">Дата</span>
                      <p className='date'>{transactionDate(transaction)}</p>
                    </td>
                    <td className={transactionReverted(transaction)}>
                      {transaction.type === 'CREDIT' && (
                          <>
                            <span className="caption">Приход, BYN</span>
                            <p>{transaction.amount.toFixed(2)}</p>
                          </>
                      )}
                    </td>
                    <td className={transactionReverted(transaction)}>
                      {transaction.type === 'DEBIT' && (
                          <>
                            {' '}
                            <span className="caption">Расход, BYN</span>
                            <p>{transaction.amount.toFixed(2)}</p>
                          </>
                      )}
                    </td>
                    <td className={transactionReverted(transaction)}>{cashValue(transaction.cash, isNonCashOperationCrediton)}</td>
                    <td className={'reports-editTransaction'}>
                      {
                          transactionUpdate(transaction) &&
                          <button
                              className="button-tab transaction-button"
                              onClick={() => openModalForTransactionEdit(transaction)}
                          >
                            Редактировать
                          </button>
                      }
                      {
                          permissionsAccess("action.transaction.revert")
                          && (methods.isRevertable(transaction.section)
                              && !transaction.reverted
                              && returnButton(transaction))
                      }
                    </td>
                  </tr>
              );
            })}
        </tbody>
      </table>
      {state.totalElements > currentPage * SIZE && (
          <div className="content-datatable-header-actions d-flex">
            <div className="content-datatable-header-center">
              <div className="action-items">
                <button className="action-item" onClick={handleShowMore}>
                  Показать еще{' '}
                  {'( показаны ' + currentPage * SIZE + ' из ' + state.totalElements + ')'}
              </button>
            </div>
          </div>
        </div>
      )}
      <ConfirmModal
        isOpen={!!revertTransaction}
        handleClose={() => {
          setRevertTransaction(undefined);
        }}
        handleAction={() => {
          setRevertTransaction(undefined);
          handleRevert(revertTransaction);
        }}
        headerText="Отменить транзакцию"
        bodyText={
          revertTransaction &&
          `Уверены что хотите отменить транзакцию ${
            methods.convertGroupType(revertTransaction.section, state.reasons) +
            (revertTransaction.description ? ' ' + revertTransaction.description : '')
          }?`
        }
      />
      <ModalInboxOperationEdit
        isOpen={modalEditTransaction}
        transactionToEdit = {transactionToEdit}
        closeModalEditTransaction={closeModalEditTransaction}
      />
    </>
  );
};

export default TransactionsDetailed;
